import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { ACCESS_REQUEST_CATALOGS } from "./model/access-request-copy.ts";
import { ACCESS_REQUEST_ERROR_COPY } from "./model/access-request-error-copy.ts";

// Asking to join an organization without an invite, and an admin's decision
// on it, S3.08: the shared link's landing screen (`/join`, any signed-in
// person) and the admin's pending list under Settings
// (`access-requests:read`/`:write`, admin-only; a 403 on the list already
// renders the "no access" boundary).
export const accessRequestsBrowserModule: BrowserModule = defineBrowserModule("access-requests")
  .withErrorCopy(ACCESS_REQUEST_ERROR_COPY)
  .withScreens({
    join: {
      path: "/join",
      title: phrase(ACCESS_REQUEST_CATALOGS, "joinScreenTitle"),
      layout: "auth",
      load: () => import("./ui/sections/join-screen.tsx"),
    },
    accessRequests: {
      path: "/settings/access-requests",
      title: phrase(ACCESS_REQUEST_CATALOGS, "accessRequestsScreenTitle"),
      layout: "app",
      load: () => import("./ui/sections/access-requests-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "access-requests",
      group: "settings-workspace",
      label: phrase(ACCESS_REQUEST_CATALOGS, "navAccessRequests"),
      href: "/settings/access-requests",
      icon: "users",
      order: 856,
    },
  ]);
